export interface AbstractControllerParams {

    rootNode:HTMLElement | null,


}

export class AbstractController {

    public rootNode:HTMLElement | null
    

    constructor(rootNode:HTMLElement | null){

        

    }

    mountUI (){}

    bindEvents (){}

    unbindEvents (){}

    parseData (){}

}